/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioGitlabIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-gitlab-dev" */ './utils').then(
			(m) => m.ForgePioGitlabIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-dev/icon' },
);

const LazyForgePioGitlabSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-gitlab-dev-search-result" */ './utils').then(
			(m) => m.ForgePioGitlabSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitlab-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioGitlabIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGitlabIconComponent />
	</Suspense>
);

export const ForgePioGitlabSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGitlabSearchResultIconComponent />
	</Suspense>
);
